module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view",
    attrs: {
      "id": "login"
    }
  }, [(!_vm.forgotPassMode) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login_user),
      expression: "login_user"
    }],
    attrs: {
      "type": "text",
      "placeholder": "User"
    },
    domProps: {
      "value": (_vm.login_user)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.login_user = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login_pwd),
      expression: "login_pwd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.login_pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.login_pwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('btn', {
    attrs: {
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.forgotPassMode = true
      }
    }
  }, [_vm._v("Glemt kodeord?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('btn', {
    attrs: {
      "color": "2",
      "full": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doLogin()
      }
    }
  }, [_vm._v("Log ind")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.forgotPassMode) ? _c('box', {
    attrs: {
      "label": "Log ind"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password_reset_email),
      expression: "password_reset_email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.password_reset_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password_reset_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn half left",
    on: {
      "click": function($event) {
        _vm.forgotPassMode = false
      }
    }
  }, [_c('div', {
    staticClass: "fa fa-angle-left"
  }), _vm._v(" Tilbage\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn a half right",
    attrs: {
      "_@click": "resetPassword"
    }
  }, [_c('div', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("\n    Nyt pass plz\n    ")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28b9a507","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 588
// module chunks = 1